import bargainActivity from './bargainActivity';
import bargainAttend from './bargainAttend';
import bargainSponsor from './bargainSponsor';
import courseClass from './courseClass';
import classTimeTable from './classTimeTable';
import coach_homeMenu from './coach/homeMenu';
import common from './common';
import coupon from './coupon';
import couponUse from './couponUse';
import course from './course';
import cSStudentAttend from './cSStudentAttend';
import cSTeacherAttend from './cSTeacherAttend';
import cusSalesManagement from './cusSalesManagement';
import customer from './customer';
import customerFollowUpRecord from './customerFollowUpRecord';
import expCourse from './expCourse';
import expCourseAttend from './expCourseAttend';
import expCourseTemplate from './expCourseTemplate';
import finance from './finance';
import fineCoach from './fineCoach';
import fineCourse from './fineCourse';
import fineStudent from './fineStudent';
import goods from './goods';
import goodsCategory from './goodsCategory';
import goodsOrder from './goodsOrder';
import holiday from './holiday';
import homePage from './homePage';
import homeWork from './homeWork';
import insurance from './insurance';
import leaveRecordStudent from './leaveRecordStudent';
import leaveRecordTeacher from './leaveRecordTeacher';
import marketingStatistics from './marketingStatistics';
import notice from './notice';
import noticeManage from './noticeManage';
import oldBeltNewRecord from './oldBeltNewRecord';
import organization from './organization';
import orgBranch from './orgBranch';
import orgConfig from './orgConfig';
import orgDictionary from './orgDictionary';
import orgFormConfig from './orgFormConfig';
import orgFranchisee from './orgFranchisee';
import orgNews from './orgNews';
import orgOrder from './orgOrder';
import orgsite from './orgsite';
import orgSourceConfig from './orgSourceConfig';
import orgStatistics from './orgStatistics';
import orguser from './orguser';
import orgUserShortcutEntry from './orgUserShortcutEntry';
import coursePackage from './package';
import param from './param';
import privilege from './privilege';
import quicklyComment from './quicklyComment';
import sCITinkerUpRecord from './sCITinkerUpRecord';
import student from './student';
import studentCardInfo from './studentCardInfo';
import studentScheduleComment from './studentScheduleComment';
import sys from './sys';
import teacherStatistics from './teacherStatistics';
import token from './token';
import wMS from './wMS';
import wMSOrder from './wMSOrder';
import wMSStock from './wMSStock';
import wXAppBanner from './wXAppBanner';
import wXAppUserBook from './wXAppUserBook';
import wXClassNoticeConfig from './wXClassNoticeConfig';
import wXFlowStatistics from './wXFlowStatistics';
import orgInsuranceSettings from './orgInsuranceSettings';
import classDayTimeRelationStudent from './classDayTimeRelationStudent';


export default{
   bargainActivity,
   bargainAttend,
   bargainSponsor,
   courseClass,
   classTimeTable,
   coach_homeMenu,
   common,
   coupon,
   couponUse,
   course,
   cSStudentAttend,
   cSTeacherAttend,
   cusSalesManagement,
   customer,
   customerFollowUpRecord,
   expCourse,
   expCourseAttend,
   expCourseTemplate,
   finance,
   fineCoach,
   fineCourse,
   fineStudent,
   goods,
   goodsCategory,
   goodsOrder,
   holiday,
   homePage,
   homeWork,
   insurance,
   leaveRecordStudent,
   leaveRecordTeacher,
   marketingStatistics,
   notice,
   noticeManage,
   oldBeltNewRecord,
   organization,
   orgBranch,
   orgConfig,
   orgDictionary,
   orgFormConfig,
   orgFranchisee,
   orgNews,
   orgOrder,
   orgsite,
   orgSourceConfig,
   orgStatistics,
   orguser,
   orgUserShortcutEntry,
   coursePackage,
   param,
   privilege,
   quicklyComment,
   sCITinkerUpRecord,
   student,
   studentCardInfo,
   studentScheduleComment,
   sys,
   teacherStatistics,
   token,
   wMS,
   wMSOrder,
   wMSStock,
   wXAppBanner,
   wXAppUserBook,
   wXClassNoticeConfig,
   wXFlowStatistics,
   orgInsuranceSettings,
   classDayTimeRelationStudent
}




// WEBPACK FOOTER //
// ./src/services/index.js